import { MutationTree } from "vuex";
import {
    ManualActionState,
    ManualPulseRequest,
	ManualResetRequest,
} from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<ManualActionState> = {
    setManualPulseData(state, data: ManualPulseRequest) {
        state.manualPulseData = data;
    },

    setManualEventResetData(state, data: ManualResetRequest) {
        state.manualEventResetData = data;
    },

    resetState(state) {
		Object.assign(state, getDefaultState());
	},
};